// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"72a7855f","400":"bbd891ab","453":"19d3740a","683":"fd864b63","774":"daf40d2c","783":"2ea6ed32","986":"428c71fa"}[chunkId] + ".chunk.js";
};